import React, { useState, useEffect } from 'react';

const COMPRESSED_SIZES = {
  madmax: {
    C0: 101.6,
    C1: 84.2,
    C2: 82.6,
    C3: 81,
    C4: 79.4,
    C5: 77.8,
    C6: 76.2,
    C7: 74.6,
    C8: 71.3,
    C9: 68.1,
  },
  bladebit: {
    C0: 101.6,
    C1: 87.54,
    C2: 86.03,
    C3: 84.46,
    C4: 82.86,
    C5: 81.26,
    C6: 79.65,
    C7: 78.05,
  },
};

const diskSizesInGB = {
  '1TB': 1000,
  '2TB': 2000,
  '3TB': 3000,
  '4TB': 4000,
  '6TB': 6100,
  '8TB': 8000,
  '10TB': 10000,
  '12TB': 12000,
  '14TB': 13800,
  '18TB': 18000,
  '20TB': 19900,
};

function FileTable() {
  const [algorithm, setAlgorithm] = useState('bladebit');
  const [diskSize, setDiskSize] = useState('10TB');
  const [filesPerDisk, setFilesPerDisk] = useState({});
  const [customCapacity, setCustomCapacity] = useState();
  const [numberOfPlots, setNumberOfPlots] = useState();

  useEffect(() => {
    const calculateFilesPerDisk = () => {
      const results = {};
      const capacity = numberOfPlots || diskSize;
      for (const compressionLevel in COMPRESSED_SIZES[algorithm]) {
        const fileSize = COMPRESSED_SIZES[algorithm][compressionLevel];
        const avgFileSize = fileSize;
        const capacityInGB = diskSizesInGB[capacity];
        if (capacityInGB) {
          const files = Math.floor((capacityInGB * 0.9313) / avgFileSize);
          results[compressionLevel] = files;
        } else {
          setCustomCapacity(numberOfPlots * 101.6);
          const files = Math.floor(customCapacity / avgFileSize);
          results[compressionLevel] = files;
        }
      }
      setFilesPerDisk(results);
    };

    calculateFilesPerDisk();
  }, [algorithm, diskSize, customCapacity, numberOfPlots]);

  const handleCustomCapacityChange = (event) => {
    const value = event.target.value;
    setNumberOfPlots(value);
    setDiskSize('');
  };

  return (
    <>
      <div
        className="d-grid mx-auto my-3 text-white"
        style={{ maxWidth: '600px' }}
      >
        <label htmlFor="algorithm-select">Select Algorithm:</label>
        <div
          className="btn-group btn-group-toggle mx-auto"
          id="algorithm-buttons"
        >
          <button
            className={
              algorithm === 'madmax'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            aria-pressed="true"
            value="madmax"
            checked
            onClick={() => setAlgorithm('madmax')}
          >
            Madmax
          </button>
          <button
            className={
              algorithm === 'bladebit'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="bladebit"
            onClick={() => setAlgorithm('bladebit')}
          >
            Bladebit
          </button>
        </div>
        <div className="d-grid mx-auto" style={{ maxWidth: '250px' }}>
          <label htmlFor="custom-disk-size-input" className="mt-3">
            Number of uncompressed plots:
          </label>
          <input
            type="number"
            id="custom-disk-size-input"
            className="text-center"
            placeholder="Insert your number of plots"
            value={numberOfPlots}
            onChange={handleCustomCapacityChange}
            onBlur={() => {
              numberOfPlots === '' ? setDiskSize('10TB') : '';
            }}
            min="1"
          />
        </div>
        <label htmlFor="disk-size-select" className="mt-3">
          Select Disk Size:
        </label>
        <div id="disk-size-buttons">
          <button
            className={
              diskSize === '1TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="1TB"
            onClick={() => {
              setDiskSize('1TB');
              setNumberOfPlots('');
            }}
          >
            1TB
          </button>
          <button
            className={
              diskSize === '2TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="2TB"
            onClick={() => {
              setDiskSize('2TB');
              setNumberOfPlots('');
            }}
          >
            2TB
          </button>
          <button
            className={
              diskSize === '3TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="3TB"
            onClick={() => {
              setDiskSize('3TB');
              setNumberOfPlots('');
            }}
          >
            3TB
          </button>
          <button
            className={
              diskSize === '4TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="4TB"
            onClick={() => {
              setDiskSize('4TB');
              setNumberOfPlots('');
            }}
          >
            4TB
          </button>
          <button
            className={
              diskSize === '6TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="6TB"
            onClick={() => {
              setDiskSize('6TB');
              setNumberOfPlots('');
            }}
          >
            6TB
          </button>
          <button
            className={
              diskSize === '8TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="8TB"
            onClick={() => {
              setDiskSize('8TB');
              setNumberOfPlots('');
            }}
          >
            8TB
          </button>
          <button
            className={
              diskSize === '10TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="10TB"
            onClick={() => {
              setDiskSize('10TB');
              setNumberOfPlots('');
            }}
          >
            10TB
          </button>
          <button
            className={
              diskSize === '12TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="12TB"
            onClick={() => {
              setDiskSize('12TB');
              setNumberOfPlots('');
            }}
          >
            12TB
          </button>
          <button
            className={
              diskSize === '14TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="14TB"
            onClick={() => {
              setDiskSize('14TB');
              setNumberOfPlots('');
            }}
          >
            14TB
          </button>
          <button
            className={
              diskSize === '18TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="18TB"
            onClick={() => {
              setDiskSize('18TB');
              setNumberOfPlots('');
            }}
          >
            18TB
          </button>
          <button
            className={
              diskSize === '20TB'
                ? 'btn btn-outline-success p-1 m-1 active'
                : 'btn btn-outline-success p-1 m-1'
            }
            value="20TB"
            onClick={() => {
              setDiskSize('20TB');
              setNumberOfPlots('');
            }}
          >
            20TB
          </button>
        </div>
      </div>
      <div
        className="container-fluid text-center d-grid justify-center text-white"
        style={{ maxWidth: '600px' }}
      >
        <table className="table-responsive ">
          <thead className="text-success">
            <tr>
              <th>Compression Level</th>
              <th>Plots Quantity</th>
              <th>Simulated Capacity</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(filesPerDisk).map(([compressionLevel, files]) => (
              <tr key={compressionLevel}>
                <td>{compressionLevel}</td>
                <td>{files}</td>
                <td>{Number((files * 101.6) / 1024).toFixed(3)} TiB</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default FileTable;
